<template>
  <el-dialog
    title="预览"
    :visible.sync="dialogVisible"
    width="800px"
    append-to-body
    top="10px"
  >
    <iframe
      :src="`./file-viewer/index.html?useOfficeMicroOnline=false&fileUrl=${fileUrl}`"
      scrolling="auto"
      style="border:0;height: 800px;width:100%"
    />
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      fileUrl: ''
    }
  },
  methods: {
    publicOpen(url) {
      this.dialogVisible = true;
      this.fileUrl = url;
    }
  }
}
</script>